import { ILayoutConfig, ICell, LayoutEvents, ILayoutEventHandlersMap } from "@dhx/ts-layout";
import { EventSystem } from "@dhx/ts-common/events";
export enum RenderMode {
	top = "top",
	bottom = "bottom",
	left = "left",
	right = "right"
}
export interface ITabbarConfig extends ILayoutConfig {
	mode?: RenderMode;
	closeButtons?: boolean;
	noContent?: boolean;
	tabWidth?: number;
	tabHeight?: number;
	css?: string;
}
export enum TabbarEvents {
	change = "change",
	close = "close"
}
export interface ITabbar extends ICell {
	config: ITabbarConfig;
	events: EventSystem<TabbarEvents | LayoutEvents, ITabbarEventHandlersMap | ILayoutEventHandlersMap>;

	toVDOM(nodes?: any[]): any;

	destructor(): void;
	paint(): void;
	removeCell(id: string): void;
	setActive(id: string): void;
	getWidget(): any;
	getActive(): string;
}
export interface ITabbarEventHandlersMap {
	[key: string]: (...args: any[]) => any;
	[TabbarEvents.change]: (id: string, prev: string) => any;
	[TabbarEvents.close]: (id: string) => any;
}